import React, { FC } from 'react';
import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../../constants';
import { BotTyping } from './index';

// Fake bot-typing node used as a loader for other nodes that require some async initialization
export const Fallback: FC = () => (
  <BotTyping id={uuid()} type={MESSAGES.BOT_TYPING} role={ROLE.BOT} avatar={false} rm={true} />
);
